import { InboxOutlined } from '@mui/icons-material';
import AddBoxOutlined from '@mui/icons-material/AddBoxOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import DirectionsCarOutlined from '@mui/icons-material/DirectionsCarOutlined';
import EventNoteOutlined from '@mui/icons-material/EventNoteOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import ListAltOutlined from '@mui/icons-material/ListAltOutlined';
import LocalPhoneOutlined from '@mui/icons-material/LocalPhoneOutlined';
import PermMediaOutlined from '@mui/icons-material/PermMediaOutlined';
import PersonOutline from '@mui/icons-material/PersonOutline';
import RuleOutlined from '@mui/icons-material/RuleOutlined';

import HomeStorageIcon from '@/assets/images/svgs/HomeStorageIcon';
import { TabItem } from '@/layouts/TabLayout';
import { AssignmentStatus } from '@/models';
import { colors } from '@/theme/variables';

export const ASSIGNMENT_STATUS = {
  [AssignmentStatus.NEW]: {
    label: 'New',
    color: colors.error.main,
  },
  [AssignmentStatus.PARTIAL_ASSIGNED]: {
    label: 'Partially assigned',
    color: colors.secondary.main,
  },
  [AssignmentStatus.ASSIGNED]: {
    label: 'Assigned',
    color: colors.primary.main,
  },
};

export const SEVERITY_STATUS = {
  HIGH: colors.error.main,
  MEDIUM: '#e3e3e3',
  LOW: colors.secondary.main,
};

export const cfsTabs: TabItem[] = [
  {
    label: 'Names',
    path: 'names',
    icon: PersonOutline,
  },
  {
    label: 'Vehicles',
    path: 'vehicles',
    icon: DirectionsCarOutlined,
  },
  {
    label: 'Properties',
    path: 'properties',
    icon: InboxOutlined,
  },
  {
    label: 'Narrative',
    path: 'narratives',
    icon: DescriptionOutlined,
  },
  {
    label: 'Related records',
    path: 'related-records',
    icon: LinkOutlined,
  },
  {
    label: 'Media',
    path: 'media',
    icon: PermMediaOutlined,
  },
  {
    label: 'Files and forms',
    path: 'files-and-forms',
    icon: HomeStorageIcon,
  },
  {
    label: 'Caller communication',
    path: 'caller-communication',
    icon: LocalPhoneOutlined,
  },
  {
    label: 'Timeline',
    path: 'timeline',
    icon: EventNoteOutlined,
  },
  {
    label: 'Logs',
    path: 'history',
    icon: ListAltOutlined,
  },
  {
    label: '911 information',
    path: '911-information',
    icon: InfoOutlined,
    hidden: true,
  },
  {
    label: 'Recommended procedure',
    path: 'procedure',
    icon: RuleOutlined,
    hidden: true,
  },
];

export const careLinkTab: TabItem = {
  label: 'CareLink',
  path: 'carelink',
  icon: AddBoxOutlined,
};
